import React from 'react';
import TimeInput from '@components/TimeInput/TimeInput';


export default class FormikTimeInput extends React.Component {

  onTimeChangeHandler(val) {
    const { form, field } = this.props;
    form.setFieldValue(field.name, val);
  }

  render() {
    const { field, placeholder } = this.props;
    return (
      <TimeInput
        initTime={field.value}
        className='form-control'
        onTimeChange={::this.onTimeChangeHandler}
        placeholder={placeholder}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/TimeInput.jsx